import { render, staticRenderFns } from "./Featured.vue?vue&type=template&id=b6edf0aa&"
import script from "./Featured.vue?vue&type=script&lang=js&"
export * from "./Featured.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports